import { api } from "../../api";

export const emailApi = api.injectEndpoints({
  endpoints: (builder) => ({
    sendEmail: builder.mutation({
      query: ({ recipients, jobId, pdfBlob, jobName, type, refId }) => ({
        url: "/email/send",
        method: "POST",
        body: {
          recipients: recipients.split(",").map((email) => email.trim()),
          jobId,
          refId,
          jobName,
          type,
          pdf: pdfBlob,
        },
      }),
    }),
  }),
});

export const { useSendEmailMutation } = emailApi;
